import { Col, Row } from "antd";
import { Loader } from "../../../../../components/Loader";
import { LinkOutlined } from "@ant-design/icons";
import { useFetchData } from "./hooks/useFetchData";
import { useCopy } from "../../../../../components/CopyButton/hooks/useCopy";
import { useCallback } from "react";

type PaymentProvidersTabProps = {
  userId: string | null;
};

export const PaymentProvidersTab = ({ userId }: PaymentProvidersTabProps) => {
  const { data, isLoading } = useFetchData(userId);

  const { copy } = useCopy();

  const onCopyClick = useCallback(
    (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
      e.stopPropagation();
      copy(data.fluidPay.profileUrl, "FluidPay profile URL was copied");
    },
    [copy, data]
  );

  return (
    <>
      {isLoading ? (
        <Loader fontSize="64px" />
      ) : (
        <Row className="d-block py-8 px-6">
          {data && (
            <Row className="align-center mb-4">
              <Col span={8}>
                <span className="text-md title">FluidPay ID</span>
              </Col>
              <Col span={16}>
                <Row>
                  {data.fluidPay && (
                    <>
                      <div title={data.fluidPay.customerId}>{data.fluidPay.customerId}</div>
                      <LinkOutlined className="ml-2 ant-btn-link" onClick={onCopyClick} />
                    </>
                  )}
                </Row>
              </Col>
            </Row>
          )}
        </Row>
      )}
    </>
  );
};
